// https://codesandbox.io/s/xkgzj?file=/demo.js
// https://gist.github.com/iamdanthedev/2a70e95d8964979f689721a34b2d15b3

import React from "react";
import { Field, ErrorMessage } from "formik";
import FormControl from "@material-ui/core/FormControl";
import { withStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Favorite from "@material-ui/icons/Favorite";
import FavoriteBorder from "@material-ui/icons/FavoriteBorder";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

function SelectList(props) {
  const {
    label,
    name,
    field,
    errorobj,
    touched,
    onChange,
    blur,
    formikobj,
    yupname,
    yupkey,
    yupvalue,
    ...rest
  } = props;

  const state = {
    age: 30,
  };
  const [age, setAge] = React.useState("");

  // const handleChange = (event, child) => {
  //   // console.log("select: ", child);
  //   // console.log("select: ", child.props.value, "-", child.props.children);
  //   try {
  //     formikobj.setFieldValue("listofage", [
  //       {
  //         age: `${child.props.value}`,
  //         value: `${child.props.children}`,
  //       },
  //     ]);
  //     console.log("Select setFieldValue");
  //   } catch (err) {
  //     formikobj.setFieldValue("listofage", null);
  //     console.log("Select setFieldValue ERROR");
  //   }

  //   setAge(event.target.value);
  // };

  const handleClickMenu = (event, value) => {
    console.log("Menu: ", event);
  };

  // console.log("Formik SelectList: ", formikobj);

  return (
    <div>
      <Field id={name} name={name} label={label} {...rest}>
        {({
          field, // { name, value, onChange, onBlur }
          form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
          meta,
        }) => (
          <div>
            <FormControl>
              <InputLabel id="simple-select-label">Age</InputLabel>
              <Select
                labelId="simple-select-label"
                name={name}
                value={age} //dropdown key for key,value pair
                onBlur={() => {
                  console.log("Select Blur");
                  formikobj.setFieldTouched(`${yupname}`);
                }}
                onChange={
                  // handleChange;
                  (e, child) => {
                    console.log("List Of Age Change", child.props.value);
                    try {
                      console.log("Select setFieldValue");
                      setAge(e.target.value);
                      if (child.props.value !== "") {
                        formikobj.setFieldValue(`${yupname}`, [
                          {
                            age: `${child.props.value}`,
                            value: `${child.props.children}`,
                          },
                        ]);
                      } else {
                        formikobj.setFieldValue(`${yupname}`, null);
                      }
                    } catch (err) {
                      setAge(null);
                      formikobj.setFieldValue(`${yupname}`, null);
                      console.log("Select setFieldValue ERROR");
                    }
                  }
                }
                autoWidth
                // renderValue={(value) => `⚠️  - ${value}`}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value={10}>Ten</MenuItem>
                <MenuItem value={20}>Twenty</MenuItem>
                <MenuItem value={30}>Thirty</MenuItem>
              </Select>
              {Object.keys(errors).length > 0 && (
                <div className="error">{errors.listofage}</div>
              )}
            </FormControl>
          </div>
        )}
      </Field>
    </div>
  );
}

export default SelectList;
